import { property, uniq } from 'underscore';
import getEvents from './get_events';

export default (state) => uniq(
  Object.values(getEvents(state)).map(property('dimensions')),
);
